'use client';

import formErrorsControl from './formErrorsControl.js';
import getFieldValidatedMessage from './getFieldValidatedMessage.js';

/*
 * Validate all fields when user submit
 * @param: {
 *    formValues: global values of form
 * }
 * */
function validateOnSubmit(formValues, requestScrollToFirstErrorElement) {
    var formRules = formValues.formRules;
    var values = formValues.values;
    var errors = formValues.errors;
    var watch = formValues.watchValues;
    // Set submit state
    formValues.isSubmited = true;
    Object.keys(formRules).map(function (key) {
        var errorMsg = getFieldValidatedMessage({
            fieldValue: values[key],
            fieldRules: formRules[key],
            fieldWatch: watch[key],
            isEnable: true
        });
        formErrorsControl({
            fieldName: key,
            formValues: formValues,
            errorMsg: errorMsg,
            requestScrollToFirstErrorElement: requestScrollToFirstErrorElement
        });
    });
    return Object.keys(errors).length > 0;
}

export { validateOnSubmit as default };
//# sourceMappingURL=validateOnSubmit.js.map
